import { getBranch } from "utils/utils";
import moment from "moment";
import { UPDATE_SEARCHTDATA_DANHSACHDONHANG } from "../../actions/DanhSachDonHang/actionTypes";
import { getUserLogin } from "utils/utils";

const initialState = {
  fromDate: moment(new Date()).format("YYYY-MM-DD"),
  toDate: moment(new Date()).format("YYYY-MM-DD"),
  typeDate: "11",
  sSearch: "",
  sUserName: getUserLogin().UserName,
  sCustomerName: "",
  iTrangThaiTruKho: -1,
  iTrangThaiThanhToan: -1,
  iBranch: getBranch(),
  sBranch: getBranch(),
  sNVKDUserName: "",
  lstNhomKH: "",
  iLoaiDon: 2,
  iLoaiDoiTac: 0,
  iPageIndex: 1,
  iPageSize: 20,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchDanhSachDonHangReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_DANHSACHDONHANG:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchDanhSachDonHangReducer;
